import { render, staticRenderFns } from "./tmall-bill.vue?vue&type=template&id=373c7029&scoped=true&"
import script from "./tmall-bill.vue?vue&type=script&lang=ts&"
export * from "./tmall-bill.vue?vue&type=script&lang=ts&"
import style0 from "./tmall-bill.vue?vue&type=style&index=0&id=373c7029&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373c7029",
  null
  
)

export default component.exports